import React, {Fragment, useEffect, useState} from 'react';
import {Checkbox, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup} from '@mui/material';
import Divider from '@mui/material/Divider';
import makeStyles from '@mui/styles/makeStyles';
import AgyleBlockSwitch from '../../../components/ui/switch/agyleBlockSwitch';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import Formatter from '../../../util/formatter';
import {user} from '../../../store/reducers/user';
import Notes from '../../../util/notes';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles((theme) => ({

    divider: {
        width: '100%',
        margin: '5px',
    },

    blockSwitch: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    textField: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    provideDetailsLabel: {
        alignItems: 'center',
    },

    radio: {
        width: '100%',
        minWidth: '100%',
    },

    mandatory: {
        fontWeight: 'bold',
        color: '#e06666',
    },
    clearButton: {
        border: '1px solid #2180f7',
        height: '25px',
        placeSelf: 'center',
    },
    container: {
        padding: '15px',
    },
    title: {
        marginBottom: '24px',
        fontWeight: 600,
        textAlign: 'center',
    },
}));

const AirwaysManagementAmbForm = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();

    // Selectors
    const userObject = useSelector(user);
    const tester = Formatter.formatUserFullName(userObject);

    const [airwaysManagementAmb, setAirwaysManagementAmb] = useState({
        basicAirwayManoeuvres:{
            aaa: false,
            bbb: false,
            ccc: false,
        },
        bagValveMask: '', //dropdown

        nasopharyngealSize: '', //dropdown
        nasopharyngealCrew: '', //dropdown

        oropharyngealSize: '', //dropdown
        oropharyngealCrew: '', //dropdown

        needleCricothyroidotomy: {
            aaa: false,
            bbb: false,
            ccc: false,
        },
        needleCricothyroidotomyCrew: '',

        endotrachealSize: '', //dropdown
        endotrachealCrew: '', //dropdown
        endotrachealAttepts: '',
        endotrachealGrade: '', //dropdown
        endotrachealUsed: {
            parapac: false,
            ventilator: false,
        },

        supraglotticSize: '', //dropdown
        supraglotticCrew: '', //dropdown

        suction: {
            aaa: false,
            bbb: false,
            ccc: false,
        },
        suctionCrew: '', //dropdown

    });

    useEffect(() => {
        if (props.patient?.studies?.airwaysManagementAmb) {
            setAirwaysManagementAmb(props.patient?.studies?.airwaysManagementAmb);
        }
    }, []);


    useEffect(() => {
        if (props.onDisableSubmit) {
            props.onDisableSubmit(isSubmitDisabled())
        }
        if (props.onSubmitFunction) {
            props.onSubmitFunction(handleSaveForm);
        }
    }, [airwaysManagementAmb, userObject]);

    const handleChangeTextField = (event) => {
        const {name, value} = event.target;
        setAirwaysManagementAmb(pr => ({
            ...pr,
            [name]: value,
        }));
    };

    const handleChangeCheckbox = (event, objectKey) => {
        const {name, checked} = event.target;
        setAirwaysManagementAmb((pr) =>
            ({
                ...pr,
                [objectKey]: {
                    ...pr[objectKey],
                    [name]: checked,
                },
            }));
    };

    const isSubmitDisabled = () => {
        //TODO poprawic zeby dzialalo z checkboxami
        return Object.values(airwaysManagementAmb).some(
            value => value == null || value === ''
        );
    };

    const handleSaveForm = () => {
        const objectToSave = {
            ...airwaysManagementAmb,
            timeStamp: moment().toISOString(),
            by: tester,
        };
        let dataArray = [{
            name: 'studies.airwaysManagementAmb',
            value: objectToSave,
        }];

        props.onChange(dataArray);
    };

    return (
        <>
            <Typography variant="h5" className={classes.title}>
                Airways Management
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={3}>
                    <FormLabel className={classes.label}>
                        {t('Basic airway manoeuvres')}
                    </FormLabel>
                </Grid>
                <Grid item xs={3}>
                    <FormControlLabel control={
                            <Checkbox
                                onChange={(event) => handleChangeCheckbox(event, 'basicAirwayManoeuvres')}
                                checked={airwaysManagementAmb.basicAirwayManoeuvres.aaa}
                                name="aaa"
                            />
                        }
                        label={t('aaa')}
                    />
                </Grid>

                <Grid item xs={3}>
                    <FormControlLabel control={
                            <Checkbox
                                onChange={(event) => handleChangeCheckbox(event, 'basicAirwayManoeuvres')}
                                checked={airwaysManagementAmb.basicAirwayManoeuvres.bbb}
                                name="bbb"
                            />
                        }
                        label={t('bbb')}
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormControlLabel control={
                            <Checkbox
                                onChange={(event) => handleChangeCheckbox(event, 'basicAirwayManoeuvres')}
                                checked={airwaysManagementAmb.basicAirwayManoeuvres.ccc}
                                name="ccc"
                            />
                        }
                        label={t('ccc')}
                    />
                </Grid>
                <Divider className={classes.divider}/>

                <Grid item xs={3}>
                    <FormLabel className={classes.label}>
                        {t('Bag valve mask')}
                    </FormLabel>
                </Grid>
                {/*dropdown*/}
                <Grid item xs={9}>
                    <AgyleTextField
                        fullWidth
                        name="bagValveMask"
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.bagValveMask}
                        variant="outlined"
                        error={!airwaysManagementAmb.bagValveMask}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Divider className={classes.divider}/>
                <Grid item xs={3}>
                    <FormLabel className={classes.label}>
                        {t('Nasopharyngeal airway')}
                    </FormLabel>
                </Grid>
                {/*dropdown*/}
                <Grid item xs={4.5}>
                    <AgyleTextField
                        fullWidth
                        label={'Size'}
                        name="nasopharyngealSize"
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.nasopharyngealSize}
                        variant="outlined"
                        error={!airwaysManagementAmb.nasopharyngealSize}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
                {/*dropdown*/}
                <Grid item xs={4.5}>
                    <AgyleTextField
                        fullWidth
                        name="nasopharyngealCrew"
                        label={'Crew member'}
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.nasopharyngealCrew}
                        variant="outlined"
                        error={!airwaysManagementAmb.nasopharyngealCrew}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Divider className={classes.divider}/>
                <Grid item xs={3}>
                    <FormLabel className={classes.label}>
                        {t('Oropharyngeal airway')}
                    </FormLabel>
                </Grid>
                {/*dropdown*/}
                <Grid item xs={4.5}>
                    <AgyleTextField
                        fullWidth
                        label={'Size'}
                        name="oropharyngealSize"
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.oropharyngealSize}
                        variant="outlined"
                        error={!airwaysManagementAmb.oropharyngealSize}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
                {/*dropdown*/}
                <Grid item xs={4.5}>
                    <AgyleTextField
                        fullWidth
                        name="oropharyngealCrew"
                        label={'Crew member'}
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.oropharyngealCrew}
                        variant="outlined"
                        error={!airwaysManagementAmb.oropharyngealCrew}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Divider className={classes.divider}/>
                <Grid item xs={3}>
                    <FormLabel className={classes.label}>
                        {t('Needle cricothyroidotomy ')}
                    </FormLabel>
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel control={
                        <Checkbox
                            onChange={(event) => handleChangeCheckbox(event, 'needleCricothyroidotomy')}
                            checked={airwaysManagementAmb.needleCricothyroidotomy.aaa}
                            name="aaa"
                        />
                    } label={t('aaa')}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel control={
                        <Checkbox
                            onChange={(event) => handleChangeCheckbox(event, 'needleCricothyroidotomy')}
                            checked={airwaysManagementAmb.needleCricothyroidotomy.bbb}
                            name="bbb"
                        />
                    } label={t('bbb')}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel control={
                        <Checkbox
                            onChange={(event) => handleChangeCheckbox(event, 'needleCricothyroidotomy')}
                            checked={airwaysManagementAmb.needleCricothyroidotomy.ccc}
                            name="ccc"
                        />
                    } label={t('ccc')}
                    />
                </Grid>

                {/*dropdown*/}
                <Grid item xs={3}>
                    <AgyleTextField
                        fullWidth
                        name="needleCricothyroidotomyCrew"
                        label={'Crew member'}
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.needleCricothyroidotomyCrew}
                        variant="outlined"
                        error={!airwaysManagementAmb.needleCricothyroidotomyCrew}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Divider className={classes.divider}/>
                <Grid item xs={3}>
                    <FormLabel className={classes.label}>
                        {t('Endotracheal ')}
                    </FormLabel>
                </Grid>
                {/*dropdown*/}
                <Grid item xs={3}>
                    <AgyleTextField
                        fullWidth
                        label={'Size'}
                        name="endotrachealSize"
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.endotrachealSize}
                        variant="outlined"
                        error={!airwaysManagementAmb.endotrachealSize}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
                {/*dropdown*/}
                <Grid item xs={3}>
                    <AgyleTextField
                        fullWidth
                        name="endotrachealCrew"
                        label={'Crew member'}
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.endotrachealCrew}
                        variant="outlined"
                        error={!airwaysManagementAmb.endotrachealCrew}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
                <Grid item xs={3}>
                    <AgyleTextField
                        fullWidth
                        label={'Attempts'}
                        name="endotrachealAttepts"
                        maxRows={25}
                        type="number"
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.endotrachealAttepts}
                        variant="outlined"
                        error={!airwaysManagementAmb.endotrachealAttepts}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
                <Grid item xs={3}/>
                {/*dropdown*/}
                <Grid item xs={3}>
                    <AgyleTextField
                        fullWidth
                        name="endotrachealGrade"
                        label={'Grade of view'}
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.endotrachealGrade}
                        variant="outlined"
                        error={!airwaysManagementAmb.endotrachealGrade}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormControlLabel control={
                        <Checkbox
                            onChange={(event) => handleChangeCheckbox(event, 'endotrachealUsed')}
                            checked={airwaysManagementAmb.endotrachealUsed.parapac}
                            name="parapac"
                        />
                    } label={t('Parapac used')}
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormControlLabel control={
                        <Checkbox
                            onChange={(event) => handleChangeCheckbox(event, 'endotrachealUsed')}
                            checked={airwaysManagementAmb.endotrachealUsed.ventilator}
                            name="ventilator"
                        />
                    } label={t('Ventilator used')}
                    />
                </Grid>

                <Divider className={classes.divider}/>
                <Grid item xs={3}>
                    <FormLabel className={classes.label}>
                        {t('Supraglottic airway')}
                    </FormLabel>
                </Grid>
                {/*dropdown*/}
                <Grid item xs={4.5}>
                    <AgyleTextField
                        fullWidth
                        label={'Size'}
                        name="supraglotticSize"
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.supraglotticSize}
                        variant="outlined"
                        error={!airwaysManagementAmb.supraglotticSize}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
                {/*dropdown*/}
                <Grid item xs={4.5}>
                    <AgyleTextField
                        fullWidth
                        name="supraglotticCrew"
                        label={'Crew member'}
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.supraglotticCrew}
                        variant="outlined"
                        error={!airwaysManagementAmb.supraglotticCrew}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>

                <Divider className={classes.divider}/>
                <Grid item xs={3}>
                    <FormLabel className={classes.label}>
                        {t('Suction')}
                    </FormLabel>
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel control={
                        <Checkbox
                            onChange={(event) => handleChangeCheckbox(event, 'suction')}
                            checked={airwaysManagementAmb.suction.aaa}
                            name="aaa"
                        />
                    } label={t('aaa')}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel control={
                        <Checkbox
                            onChange={(event) => handleChangeCheckbox(event, 'suction')}
                            checked={airwaysManagementAmb.suction.bbb}
                            name="bbb"
                        />
                    } label={t('bbb')}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel control={
                        <Checkbox
                            onChange={(event) => handleChangeCheckbox(event, 'suction')}
                            checked={airwaysManagementAmb.suction.ccc}
                            name="ccc"
                        />
                    } label={t('ccc')}
                    />
                </Grid>
                {/*dropdown*/}
                <Grid item xs={3}>
                    <AgyleTextField
                        fullWidth
                        name="suctionCrew"
                        label={'Crew member'}
                        maxRows={25}
                        multiline
                        onChange={handleChangeTextField}
                        value={airwaysManagementAmb.suctionCrew}
                        variant="outlined"
                        error={!airwaysManagementAmb.suctionCrew}
                        noBorder={false}
                        withNewBackground
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default AirwaysManagementAmbForm;